document.addEventListener('DOMContentLoaded', function () {
  const content = document.querySelector('.article-template__content');
  if (!content) return;

  const blockTags = new Set(['P', 'DIV', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'UL', 'OL', 'LI', 'BLOCKQUOTE']);
  const elements = Array.from(content.querySelectorAll('p, div'));

  for (const el of elements) {
    const text = el.textContent.trim();
    let html = null;

    // --- divider patterns: only plain <p> with no element children
    if (el.tagName === 'P' && el.children.length === 0) {
      if (text.startsWith('--- ') && text.endsWith(' ---')) {
        const label = text.slice(4, -4).trim();
        html = `<div class="mm-divider mm-divider--text-center">
  <span class="mm-divider__line"></span>
  <span class="mm-divider__text">${label}</span>
  <span class="mm-divider__line"></span>
</div>`;
      } else if (text === '---') {
        html = `<div class="mm-divider mm-divider--no-text" role="separator">
  <span class="mm-divider__line"></span>
  <span class="mm-divider__ornament" aria-hidden="true">◆</span>
  <span class="mm-divider__line"></span>
</div>`;
      } else if (text.startsWith('--- ')) {
        const label = text.slice(4).trim();
        html = `<div class="mm-divider mm-divider--text-left">
  <span class="mm-divider__text">${label}</span>
  <span class="mm-divider__line"></span>
</div>`;
      } else if (text.endsWith(' ---')) {
        const label = text.slice(0, -4).trim();
        html = `<div class="mm-divider mm-divider--text-right">
  <span class="mm-divider__line"></span>
  <span class="mm-divider__text">${label}</span>
</div>`;
      }
    }

    // // caption: works on <p> or <div>, as long as no block-level children
    if (html === null && text.startsWith('// ')) {
      const hasBlockChildren = Array.from(el.children).some(child => blockTags.has(child.tagName));
      if (!hasBlockChildren) {
        const label = text.slice(3).trim();
        const alignment = el.style.textAlign;
        const alignAttr = alignment ? ` style="text-align: ${alignment}"` : '';
        const alignMod = (alignment === 'center' || alignment === 'right') ? ` mm-caption--${alignment}` : '';
        html = `<div class="mm-caption caption-with-letter-spacing caption-with-letter-spacing--medium${alignMod}"${alignAttr}>${label}</div>`;
      }
    }

    if (html !== null) {
      el.insertAdjacentHTML('afterend', html);
      el.remove();
    }
  }
});
